import { Fragment } from 'react';

import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';

import { Link, LinkProps } from '../../Link';
import { Text, TextProps } from '../../Text';

const { formLayout: formLayoutTokens } = tokens;

export type LegalCopyProps = Partial<TextProps> & {
  /**
   * Links to display in the legal copy
   */
  links?: Array<
    Omit<LinkProps, 'children'> & {
      /**
       * Text to display in the link
       */
      text: string;
    }
  >;
};

/**
 * Legal copy for forms. Accepts an array of links to display. Can be customized
 * by passing `TextProps`.
 */
export const LegalCopy = ({ links = [], ...props }: LegalCopyProps) => {
  return (
    <Text
      tag="small"
      typography={formLayoutTokens.typography.legalText}
      color={formLayoutTokens.color.content.legalText.default}
      {...props}
    >
      &copy; {new Date().getFullYear()} Opendoor | Equal Housing Opportunity
      {links.length > 0 ? ' | ' : ''}
      {links.map(({ text, ...linkProps }, idx) => (
        <Fragment key={text}>
          <Link
            variant="secondary"
            typography={formLayoutTokens.typography.legalText}
            color={formLayoutTokens.color.content.legalText.default}
            {...linkProps}
          >
            {text}
          </Link>
          {idx === links.length - 1 ? '' : ' · '}
        </Fragment>
      ))}
    </Text>
  );
};
